import { useNavigate } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import SidePanelAdmin from '@CommonFunctionalDisplay/SidePanelAdmin';
import TopPanelAdmin from '@CommonFunctionalDisplay/TopPanelAdmin';
import './CheckoutSuccessPage.scss';

export default function CheckoutSuccessPage() {
    const navigate = useNavigate();
    const className = 'checkoutSuccessPage';

    return (
        <div className={className}>
            <SidePanelAdmin />
            <TopPanelAdmin />
            <div className={className + '__body'}>
                <div className={className + '__card'}>
                    <div className={className + '__icon-wrapper'}>
                        <span className={className + '__ring ' + className + '__ring--1'} />
                        <span className={className + '__ring ' + className + '__ring--2'} />
                        <span className={className + '__ring ' + className + '__ring--3'} />
                        <CheckCircle2 size={56} className={className + '__icon'} />
                    </div>
                    <h1 className={className + '__title'}>Payment successful!</h1>
                    <p className={className + '__subtitle'}>
                        Your subscription is now active. Welcome aboard.
                    </p>
                    <button
                        className={className + '__cta'}
                        onClick={() => navigate('/dashboard')}
                    >
                        Go to Dashboard <ArrowRight size={18} />
                    </button>
                </div>
            </div>
        </div>
    );
}
